@if (totalPages > 1) {
  <div class="d-block d-md-none">
    <!--small view devices-->
    <div class="d-flex text-center my-2">
      <div class="w-25 p-1">
        <button
          class="btn btn-secondary w-100"
          type="button"
          [disabled]="previous === 0"
          (click)="
            previous = previous - pageSize;
            pageNum = pageNum - 1;
            changePagination()
          "
        >
          <i class="fas fa-arrow-left"></i>
        </button>
      </div>
      <div class="w-50 p-1 d-flex justify-content-center align-items-center">
        @if (totalPages > 1) {
          <form [formGroup]="pageForm">
            <input
              type="tel"
              inputmode="numeric"
              pattern="[0-9]*"
              list="numbers"
              class="form-control number-input"
              [min]="1"
              [max]="totalPages"
              formControlName="pageNum"
            />
          </form>
          <datalist id="numbers">
            @for (number of pageNumbers; track number) {
              <option [value]="number">
                {{ number }}
              </option>
            }
          </datalist>
        } @else {
          {{ pageNum }}
        }
        of {{ totalPages }}
      </div>
      <div class="w-25 p-1">
        <button
          class="btn btn-secondary w-100"
          type="button"
          [disabled]="previous + pageSize >= totalRows"
          (click)="
            previous = previous + pageSize;
            pageNum = pageNum + 1;
            changePagination()
          "
        >
          <i class="fas fa-arrow-right"></i>
        </button>
      </div>
    </div>
  </div>
}
<div class="d-none d-md-block px-3">
  <!--large view devices-->

  <div class="d-flex justify-content-end align-items-center my-2">
    @if (totalRows > paginationValues[0] && !fixedRows) {
      <div class="me-2">Items per page</div>
      <select
        class="form-control me-2 w-auto number-input"
        [(ngModel)]="pageSize"
        (change)="previous = 0; pageNum = 1; changePagination()"
      >
        @for (paginationval of paginationValues; track paginationval) {
          <option [value]="paginationval">
            {{ paginationval }}
          </option>
        }
      </select>
    }
    @if (totalPages > 1) {
      <button
        class="btn btn-secondary btn-sm me-2"
        [disabled]="previous === 0"
        (click)="
          previous = previous - pageSize;
          pageNum = pageNum - 1;
          changePagination()
        "
      >
        <i class="fas fa-arrow-left"></i>
      </button>
      @if (totalPages > 1) {
        <form [formGroup]="pageForm">
          <input
            type="tel"
            inputmode="numeric"
            pattern="[0-9]*"
            list="numbers"
            class="form-control number-input"
            [min]="1"
            [max]="totalPages"
            formControlName="pageNum"
          />
        </form>
        <datalist id="numbers">
          @for (number of pageNumbers; track number) {
            <option [value]="number">
              {{ number }}
            </option>
          }
        </datalist>
      } @else {
        {{ pageNum }}
      }
      of {{ totalPages }}
      <button
        class="btn btn-secondary btn-sm ms-2"
        [disabled]="previous + pageSize >= totalRows"
        (click)="
          previous = previous + pageSize;
          pageNum = pageNum + 1;
          changePagination()
        "
      >
        <i class="fas fa-arrow-right"></i>
      </button>
    }
  </div>
</div>
